import React from "react";
import moment from "moment";
import { get, map, isString, isObject } from "lodash";
import { Card, Row, Col, Typography } from "antd";
import { UserOutlined, CalendarOutlined, SettingOutlined } from "@ant-design/icons";
import { useSmartAssistStore } from "../store";
import InfoCard from "./InfoCard";
const { Title } = Typography;

const CallDisposition = () => {
  const { preReadSmartAssist } = useSmartAssistStore();
  const {
    coin,
    coinActivity,
    csat,
    engagement,
    eventData,
    expectationMonth,
    formResponse,
    kitData,
    limitedComments,
    resultExpec,
    ticket,
    orderDetails = [],
  } = preReadSmartAssist;

  const comments = get(preReadSmartAssist, ['limitedComments'], []);
  const engagementData = get(engagement, "value", []);
  const formResponseData = get(formResponse, "value", []);

  function processFormData(formResponseData) {
    return map(formResponseData, formEntry => {
      let questionData = formEntry?.question;

      // Attempt to parse JSON if the question is a string
      if (isString(questionData)) {
        try {
          questionData = JSON.parse(questionData);
        } catch {
          // If parsing fails, keep the original string
        }
      }
      // Process question data for display
      const questionText = isObject(questionData)
        ? map(questionData, (translation, language) =>
          `${language}: ${translation?.toString() ?? ''}`).join(' ') : questionData?.toString() ?? '';

      return `${questionText} : ${formEntry?.response}`;
    }).join('\n ');
  }

  return (
    <Card
      style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
      title={<Title level={4} style={{ margin: 0 }}>Latest Call Disposition</Title>}
    >
      <Row gutter={16}>
        <Col span={8} style={{ fontSize: '12px' }}>
          <InfoCard
            icon={<UserOutlined style={{ color: "#1890ff" }} />}
            title="Comment"
            style={{ fontSize: '12px' }}
            content={comments.map(comment => (
              <React.Fragment key={comment?.id}>
                {comment?.user?.first_name} : {comment?.comment_text}, Created At : {moment(comment?.created_at).format("YYYY-MM-DD HH:mm:ss")}
              </React.Fragment>
            ))}
          />
        </Col>
        <Col span={8}>
          <InfoCard
            icon={<CalendarOutlined style={{ color: "#52c41a" }} />}
            title="Customer Report"
            content={processFormData(formResponseData)}
          />
        </Col>
        <Col span={8}>
          <InfoCard
            icon={<SettingOutlined style={{ color: "#fa8c16" }} />}
            title="Engagement Summary"
            style={{ fontSize: '12px' }}
            content={engagementData.map((eng, index) => (
              <React.Fragment key={index}>
                Tag: {eng?.tag || "N/A"}, Created At: {moment(eng?.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                <br />
              </React.Fragment>
            ))}
          />
        </Col>
      </Row>
    </Card>
  )
};

export default CallDisposition;
